import { useGridApiRef } from "@mui/x-data-grid";
import { useState } from "react";
import { sortByKey } from "src/helpers/user/helper";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getMunicipalitiesApi } from "src/redux/qualify_for_habi/api";
import {
  setFeedName,
  setFilters,
  setFiltersRequest,
  setMessagesSended,
  setRowsSelected,
  setRowsSelectedWhatsapp,
  setShowWhatsAppConfirmation,
  setUniqueValuesCount,
} from "src/redux/qualify_for_habi/qualifyForHabi.slice";
import { getFeedNameList, getPropertiesQualifyForHabi } from "src/redux/qualify_for_habi/qualifyForHabi.thunks";
import {
  selectFeedNameList,
  selectFilters,
  selectResults,
  selectRowsSelected,
  selectWhatsapp,
} from "src/redux/qualify_for_habi/selects";
import { selectUser } from "src/redux/user/userSlice";

export const useQualifyPropertyHabi = () => {
  const dispatch = useAppDispatch();
  const { token } = useAppSelector(selectUser);
  const [loading, setLoading] = useState(false);
  const filters = useAppSelector(selectFilters);
  const [municipalities, setMunicipalities] = useState([]);
  const [municipalitySelected, setMunicipalitySelected] = useState<number>();
  const results = useAppSelector(selectResults);
  const apiRef = useGridApiRef();
  const { rowsSelected } = useAppSelector(selectRowsSelected);
  const { feed_name_list, loading_feed } = useAppSelector(selectFeedNameList)

  const {
    open_whatsapp_confirmation: showModal,
    modal_message: modalMessage,
    loading_whatsapp
  } = useAppSelector(selectWhatsapp);

  const today = new Date();
  const week = 1000 * 60 * 60 * 24 * 7;
  const lastWeek = new Date(today.getTime() - week);
  const initialValues = {
    date_end: today,
    date_init: lastWeek,
    price_min: "0",
    price_max: "52000000",
    broker_type: [],
    city_id: [],
    leads_count: "100",
    zone_classification: [],
    feed_name: [],
    from_xml: 3
  };
  const clearSelected = () => {
    rowsSelected?.forEach((row) => {
      apiRef.current.selectRow(row, false);
    });
  };

  const handleSetCloseModal = async () => {
    clearSelected();
    dispatch(setShowWhatsAppConfirmation({ open: false, message: "" }));
    dispatch(getPropertiesQualifyForHabi());
    dispatch(setMessagesSended(0))
  };

  const getMunicipalities = async (stateId, reason, { option }) => {
    setLoading(true);
    if (reason === "selectOption") {
      const municipalitiesResponse = await getMunicipalitiesApi(token, stateId);
      const municipalitiesConcat = municipalitiesResponse.data.municipalities.map((municipaliti) => {
        return {
          city_id: municipaliti.city_id,
          name: `${stateId} - ${municipaliti.name}`,
          state_id: stateId
        }
      })
      setMunicipalities(sortByKey([...municipalities, ...municipalitiesConcat], "name"));
    } else {
      const newList = municipalities.filter((municipaliti) => municipaliti.state_id !== option.value)
      const sortList = sortByKey(newList, "name")
      setMunicipalities(sortList);
    }
    setLoading(false);
  };

  const handleSubmit = () => {
    const city_id =
      filters?.city_id?.length > 0
        ? filters.city_id.map((city) => city.city_id)
        : [];
    const broker_type =
      filters?.broker_type?.length > 0
        ? filters.broker_type.map((user) => user.id)
        : [];
    const zone_classification = filters?.zone_classification?.length > 0
      ? filters.zone_classification.map((zone) => zone.value)
      : [];

    const params = {
      ...filters,
      date_end: new Date(filters.date_end).toISOString(),
      date_init: new Date(filters.date_init).toISOString(),
      city_id: city_id.toString(),
      broker_type: broker_type.toString(),
      zone_classification: zone_classification.toString(),
      property_exported: Number(filters?.property_exported),
      user_exported: Number(filters?.user_exported),
      is_interested: Number(filters?.is_interested),
    };
    dispatch(setFiltersRequest({ ...params }));
    dispatch(getPropertiesQualifyForHabi());
  };

  const handleSetFilters = (key, value) => {
    dispatch(setFilters({ [key]: value }));
  };

  const setUniqueValues = (itemsSelected) => {
    let uniqueValues = [];
    let propertiesArray = [];
    results.forEach((result) => {
      if(itemsSelected.includes(result.id) && !uniqueValues.includes(result.phone_contact)){
        uniqueValues.push(result.phone_contact);
        const propertiesSamePhone = results.filter(element => element.phone_contact === result.phone_contact)
        const propertiesSelected = propertiesSamePhone.filter((property) => itemsSelected.includes(property.id))
        const propertiesGroup = propertiesSelected.map(property => property.id)
        propertiesArray.push(propertiesGroup);
      }
    });
    dispatch(setUniqueValuesCount(propertiesArray.length));
    dispatch(setRowsSelectedWhatsapp(propertiesArray));
  };

  const handleClick = (data) => {
    setUniqueValues(data);
    dispatch(setRowsSelected(data));
  };

  const handleSetMunicipalities = (value, setFieldValue, reason, option) => {
    if (Number(value) > 0) {
      setMunicipalitySelected(value);
      getMunicipalities(value, reason, option);
    } else {
      setMunicipalities([]);
      setFieldValue("city_id", []);
      setMunicipalitySelected(0);
    }
  };

  const handleChangeValues = (setFieldValue, key, value) => {
    if (value === "1" && key === "from_xml") {
      dispatch(getFeedNameList())
    } else if ((value === "0" || value === 3) && key === "from_xml") {
      dispatch(setFeedName([]))
      setFieldValue("feed_name", [])
      handleSetFilters("feed_name", []);
    }
    handleSetFilters(key, value);
    setFieldValue(key, value);
  };

  const handleChangeValuesAutocomplete = (setFieldValue, key, _, value) => {
    handleSetFilters(key, value);
    setFieldValue(key, value);
  };


  const handleChangeState = (setFieldValue, _: any, value, reason, option) => {
    if (value.length === 0) {
      handleChangeValues(setFieldValue, "city_id", []);
    }
    handleSetMunicipalities(value[value.length - 1]?.value, setFieldValue, reason, option);
    handleChangeValues(setFieldValue, "state_list", value);
  }

  return {
    municipalities,
    getMunicipalities,
    handleSetCloseModal,
    loading,
    handleSubmit,
    handleSetFilters,
    handleClick,
    municipalitySelected,
    handleChangeState,
    handleChangeValues,
    handleChangeValuesAutocomplete,
    apiRef,
    showModal,
    modalMessage,
    loading_whatsapp,
    initialValues,
    feed_name_list,
    loading_feed
  };
};
